import { render, staticRenderFns } from "./ReceiptsEditFormSidebar.vue?vue&type=template&id=af9d5dac&scoped=true"
import script from "./ReceiptsEditFormSidebar.vue?vue&type=script&lang=js"
export * from "./ReceiptsEditFormSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9d5dac",
  null
  
)

export default component.exports